import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CardHeader from '@material-ui/core/CardHeader'
import Card from '@material-ui/core/Card'
import { withStyles } from '@material-ui/core/styles'
import Divider from '@material-ui/core/Divider'
import Avatar from '@material-ui/core/Avatar'
import ActionsBarComponent from './ActionsBarComponent'
import BarIcon from '@material-ui/icons/LocalBar'
import moment from 'moment'
import Grid from '@material-ui/core/Grid'
import EuroIcon from '@material-ui/icons/EuroSymbol'
import EightBallIcon from 'components/EightBallIcon'
import Typography from '@material-ui/core/Typography'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import List from '@material-ui/core/List'

const styles = theme => ({
  container: {
    borderRadius: '5px',
    overflow: 'hidden',
    height: 'calc(100%)'
  },
  cyclesContainer: {
    overflow: 'auto',
    height: 'calc(100% - 200px)'
  },
  card: {
    paddingBottom: 0
  },
  actions: {
    display: 'flex'
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    }),
    marginLeft: 'auto'
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
    width: '50px',
    height: '50px'
  },
  actionCard: {
    flex: '0 1 auto',
    color: theme.palette.primary.main
  }
})

class BarInfoComponent extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
    transaction: PropTypes.object.isRequired,
    prepareForPayment: PropTypes.func.isRequired,
    showModal: PropTypes.func.isRequired
  }

  render() {
    const { classes, theme, transaction } = this.props
    const { bar } = transaction
    if (!bar) return null
    let total = 0
    let totalBillard
    if (transaction) {
      if (transaction.products) {
        Object.keys(transaction.products).map(key => {
          total += Number(transaction.products[key].price)
          return null
        })
      }
      if (transaction.pool) {
        totalBillard = Number(transaction.pool.total)
        total += Number(transaction.pool.total)
        if (transaction.pool.transfert) {
          totalBillard += Number(transaction.pool.transfert.total)
          total += Number(transaction.pool.transfert.total)
        }
      }
    }

    return (
      <Card className={classes.container}>
        <CardHeader
          classes={{ action: classes.actionCard }}
          title={<Typography variant="title">{bar.name}</Typography>}
          subheader={moment(transaction.createdAt).format('HH:mm')}
          avatar={
            <Avatar
              className={classes.avatar}
              style={(bar || {}).color ? { backgroundColor: bar.color } : {}}>
              <BarIcon color="inherit" />
            </Avatar>
          }
          action={
            <Grid
              container
              direction="row"
              alignItems="center"
              justify="center">
              <Grid item>
                <List>
                  <ListItem>
                    <ListItemIcon style={{ color: theme.palette.primary.main }}>
                      <EuroIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography variant="title">
                          {total.toFixed(2)}
                        </Typography>
                      }
                    />
                  </ListItem>
                  {totalBillard && (
                    <ListItem>
                      <ListItemIcon
                        style={{ color: theme.palette.primary.main }}>
                        <EightBallIcon />
                      </ListItemIcon>
                      <ListItemText primary={`(${totalBillard.toFixed(2)})`} />
                    </ListItem>
                  )}
                </List>
              </Grid>
            </Grid>
          }
        />
        <Divider />
        <ActionsBarComponent
          transaction={transaction}
          prepareForPayment={this.props.prepareForPayment}
          showModal={this.props.showModal}
        />
        <Divider />
      </Card>
    )
  }
}

export default withStyles(styles, { withTheme: true })(BarInfoComponent)



// WEBPACK FOOTER //
// ./src/routes/Bar/components/BarInfoComponent.js